import { createElement, useRef } from 'react';
import { uuid } from '../../../../utils';
const Svg = ({ color, width = 460, height = 36 }) => {
    const { linearGradient1, linearGradient2 } = useRef({
        linearGradient1: `tb3linearGradient1${uuid()}`,
        linearGradient2: `tb3linearGradient2${uuid()}`,
    }).current;
    return (createElement("svg", { width: `${width}px`, height: `${height}px` },
        createElement("defs", null,
            createElement("linearGradient", { x1: "13.7030928%", y1: "17.2427409%", x2: "86.2444302%", y2: "87.5573952%", id: `${linearGradient1}` },
                createElement("stop", { stopColor: `${color}`, offset: "0%" }),
                createElement("stop", { stopColor: `${color}`, stopOpacity: "0", offset: "100%" })),
            createElement("linearGradient", { x1: "3.5908776e-14%", y1: "50%", x2: "100%", y2: "50%", id: `${linearGradient2}` },
                createElement("stop", { stopColor: `${color}`, offset: "0%" }),
                createElement("stop", { stopColor: `${color}`, stopOpacity: "0", offset: "100%" }))),
        createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            createElement("g", { transform: "translate(-40.000000, -1803.000000)" },
                createElement("g", { transform: "translate(40.000000, 1803.000000)" },
                    createElement("circle", { stroke: `url(#${linearGradient1})`, cx: "18", cy: "18", r: "17.5" }),
                    createElement("circle", { stroke: "url(#linearGradient-1)", strokeWidth: "0.5", opacity: "0.4", cx: "18", cy: "18", r: "13.75" }),
                    createElement("polyline", { stroke: `url(#${linearGradient2})`, points: `${width - 1} 35 35 35 18.5 18.5` }),
                    createElement("rect", { fill: `${color}`, transform: "translate(18.500000, 18.500000) rotate(45.000000) translate(-18.500000, -18.500000) ", x: "15", y: "15", width: "7", height: "7" }))))));
};
export default Svg;
